import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M69.1 12.98C63 5.94001 49.2099 1.78003 41.1899 1.78003C33.1699 1.78003 19.26 5.95001 13.16 12.98C2.22001 25.59 9.68003 53.33 9.68003 53.33C9.68003 53.33 10.43 30.87 18.63 24.22C25.62 18.56 32.03 20.73 41.13 20.73C50.23 20.73 56.65 18.56 63.63 24.22C71.83 30.87 72.5799 53.33 72.5799 53.33C72.5799 53.33 80.04 25.59 69.1 12.98Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M21.21 6.8501C21.21 6.8501 30.9099 8.23012 34.8199 20.7801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M15.6099 11.5C15.6099 11.5 20.6499 11.49 24.0099 21.29" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M11.1401 15.4001C11.1401 15.4001 16.6102 14.7101 17.6702 24.5601"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M61.05 6.8501C61.05 6.8501 51.3499 8.23012 47.4399 20.7801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M66.65 11.5C66.65 11.5 61.61 11.49 58.25 21.29" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M71.1301 15.4001C71.1301 15.4001 65.6601 14.7101 64.6001 24.5601"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.76 12.98C12.76 12.98 6.4799 24.73 12.0799 36.94"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M69.49 12.98C69.49 12.98 75.77 24.73 70.17 36.94"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M41.1237 18.6158C41.0018 17.9606 40.9109 17.3012 40.8369 16.6349L40.8368 16.6345C40.689 15.3141 40.62 13.9927 40.62 12.6601L40.62 12.6564C40.6101 11.3388 40.6887 10.0187 40.8369 8.68545L41.1237 18.6158ZM41.1237 18.6158C41.2455 17.9617 41.3337 17.3035 41.4027 16.6385C41.5412 15.3028 41.62 13.9802 41.62 12.6601C41.62 11.3275 41.5509 10.0061 41.4031 8.68572L41.4031 8.68531C41.329 8.01908 41.2408 7.36106 41.1207 6.70819C40.9998 7.36365 40.9112 8.02168 40.8369 8.68531L41.1237 18.6158Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M6.86106 27.5141L1.28322 24.0531L7.79475 20.0689L6.86106 27.5141ZM14.7599 13.7157L8.95717 18.0718L9.22089 10.6785L14.7599 13.7157Z"
        fill="white"
        stroke={outline}
      />
      <path
        d="M73.0294 10.6785L73.2931 18.0718L67.4903 13.7157L73.0294 10.6785ZM75.3892 27.5141L74.4555 20.0689L80.967 24.0531L75.3892 27.5141Z"
        fill="white"
        stroke={outline}
      />
    </g>
  )
}
